// import React, { useEffect, useState } from 'react';
// import './Nav.css';

// export default function Nav() {
//   const [compact, setCompact] = useState(false);

//   useEffect(() => {
//     const onScroll = () => setCompact(window.scrollY > 60);
//     window.addEventListener('scroll', onScroll);
//     return () => window.removeEventListener('scroll', onScroll);
//   }, []);

//   return (
//     <nav className={`nav${compact ? ' nav--compact' : ''}`}>
//       <a href="#hero" className="nav-logo">
//         <img src="/logo.PNG" alt="Grantsman Security Consulting" className="nav-logo-img" />
//       </a>
//       <ul className="nav-links">
//         <li><a href="#about">About</a></li>
//         <li><a href="#mission">Mission</a></li>
//         <li><a href="#services">Services</a></li>
//         <li><a href="#scrip">SCRIP</a></li>
//         <li><a href="#contact" className="nav-cta">Contact Us</a></li>
//       </ul>
//     </nav>
//   );
// }





import React, { useEffect, useState } from 'react';
import './Nav.css';

export default function Nav() {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    const onScroll = () => setCompact(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`nav${compact ? ' nav--compact' : ''}`}>
      <a href="#hero" className="nav-logo">
        GRANTSMAN
      </a>
      <ul className="nav-links">
        <li><a href="#about">About</a></li>
        <li><a href="#mission">Mission</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#scrip">SCRIP</a></li>
        <li><a href="#contact" className="nav-cta">Contact Us</a></li>
      </ul>
    </nav>
  );
}
